




















































import Vue from 'vue'
import SidebarRelatedItems from './SidebarRelatedItems.vue'
import { LinkCategory, CmsSidebarRelatedItems } from '../types'
import SidebarLinkCategory from './SidebarLinkCategory.vue'
import SidebarRelatedSectionLink from './SidebarRelatedSectionLink.vue'

export default Vue.extend({
  components: {
    SidebarLinkCategory,
    SidebarRelatedItems,
    SidebarRelatedSectionLink
  },
  props: {
    linkCategory: {
      type: Object as () => LinkCategory,
      default: null
    },
    relatedCmsMagazines: {
      type: Array as () => CmsSidebarRelatedItems[],
      default: () => []
    },
    relatedCmsCategories: {
      type: Array as () => CmsSidebarRelatedItems[],
      default: () => []
    }
  },
  data() {
    return {
      defaultLinkCategory: {
        fullpath: '/',
        icon_image: '~common/sidebar-all-categories.png',
        icon_image_alt: 'to top page',
        display_name: 'グッズ・ノベルティ'
      } as LinkCategory
    }
  }
})
